// extracted by mini-css-extract-plugin
module.exports = {"audioWrapper":"ready-video_audioWrapper__2oxOR","iframe":"ready-video_iframe__3ubGB"};